module.exports = __webpack_public_path__ + "static/media/super_pack_en_printemps_chat.4461bf46.png";